"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
// eslint-disable-line import/no-extraneous-dependencies


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Parsers


var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _glamor = require("glamor");

var _typography = require("@bodhi-project/typography");

var _parsers = require("./parsers/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff
var Fragment = _react2.default.Fragment;
var Ul = _typography.Elements.Ul,
    Ol = _typography.Elements.Ol;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------

var wrapperStyles = (0, _glamor.css)({
  "& h2, h3, h4, h5, h6": {
    "& a.a": {
      color: "inherit",
      borderBottom: "none",

      "&:hover": {
        borderBottom: "none"
      },
      "&:visited": {
        textDecoration: "none"
      },
      "&:link": {
        textDecoration: "none"
      },
      "&:active": {
        textDecoration: "none"
      }
    },

    "& a.d": {
      color: "#0000FF",
      borderBottom: "none",
      WebkitTransition: "all 300ms cubic-bezier(0.78, 0.14, 0.15, 0.86)",
      transition: "all 300ms cubic-bezier(0.78, 0.14, 0.15, 0.86)",
      position: "absolute",
      left: "-6%",
      opacity: 0,

      "&:hover": {
        color: "#0000FF",
        borderBottom: "none"
      },
      "&:visited": {
        textDecoration: "none"
      },
      "&:link": {
        textDecoration: "none"
      },
      "&:active": {
        textDecoration: "none"
      }
    },

    "&:hover": {
      "& a.d": {
        opacity: 1,
        color: "#0000FF"
      }
    }
  },

  "& blockquote": {
    "@media(max-width: 768px)": {
      margin: "8px 12px 8px 12px"
    }
  }
});
var wrapperStylesClass = wrapperStyles.toString();

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------ Tree Parser
// ------------------------------------------------------------------------------
/**
 * treeParser
 */
var treeParser = function treeParser(markdownAst) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var frontMatterIndex = _lodash2.default.findIndex(_lodash2.default.slice(markdownAst.children, 1), function (child) {
    return child.type === "thematicBreak";
  }) + 2;
  var splicedAst = _lodash2.default.slice(markdownAst.children, frontMatterIndex);
  var headings = {
    depths: {
      first: 0,
      second: 0,
      third: 0,
      fourth: 0,
      fifth: 0
    },
    currentIndex: {
      pretty: undefined,
      dirty: []
    }
  };
  var firstHeadingInstance = true;
  var lasHeadings = headings;
  var gallery = [];
  var elementCount = splicedAst.length;

  return _react2.default.createElement(
    "div",
    {
      className: "" + wrapperStylesClass + (!_lodash2.default.isUndefined(options.className) ? " " + options.className : ""),
      style: _extends({}, options.style)
    },
    splicedAst.map(function (element, index) {
      var prepend = _react2.default.createElement(Fragment, null);
      var frag = _react2.default.createElement(Fragment, null);
      var append = _react2.default.createElement(Fragment, null);

      if (gallery.length !== 0) {
        // Gallery is not empty
        if (!_lodash2.default.isUndefined(element.children)) {
          if (element.children[0].type !== "image" && element.children[0].type !== "imageReference") {
            // The current item is not a paragraph
            prepend = (0, _parsers.galleryParser)(gallery, options, type);
            gallery = []; // Reset gallery
          }
        }
      }

      if (element.type === "paragraph") {
        if (!(element.children[0].type === "image" || element.children[0].type === "imageReference")) {
          frag = (0, _parsers.paragraphParser)(element, options);
        } else {
          if (element.children[0].type === "image") {
            gallery.push(_extends({
              src: element.children[0].url,
              alt: element.children[0].alt
            }, (0, _parsers.extractWidthHeight)(element.children[0].url)));
          } else if (element.children[0].type === "imageReference") {
            gallery.push(_extends({
              src: element.children[1].value,
              alt: element.children[0].alt
            }, (0, _parsers.extractWidthHeight)(element.children[1].value)));
          } else if (element.children[0].type === "linkReference" || element.children[0].type === "link") {
            frag = (0, _parsers.linkParser)(element, options, type);
          } else {
            frag = _react2.default.createElement(Fragment, null);
          }
        }
      }

      if (element.type === "code") {
        frag = (0, _parsers.codeParser)(element);
      }

      if (element.type === "blockquote") {
        frag = (0, _parsers.blockquoteParser)(element, options);
      }

      if (element.type === "list") {
        if (element.ordered === true) {
          frag = _react2.default.createElement(
            Ol,
            { className: "mask-p" },
            element.children.map(function (listItem, index2) {
              return _react2.default.createElement(
                "li",
                { key: index2 },
                listItem.children[0].children[0].value
              );
            })
          );
        } else {
          frag = _react2.default.createElement(
            Ul,
            { className: "mask-p" },
            element.children.map(function (listItem, index2) {
              return _react2.default.createElement(
                "li",
                { key: index2 },
                listItem.children[0].children[0].value
              );
            })
          );
        }
      }

      if (element.type === "heading") {
        lasHeadings = headings; // Save last headings
        headings = (0, _parsers.trackHeadings)(element, headings);
        headings = (0, _parsers.trackCurrentIndex)(lasHeadings, headings, firstHeadingInstance);
        firstHeadingInstance = false;
        frag = (0, _parsers.headingParser)(element, headings, options, type);
      }

      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ This is the last element
      if (index + 1 === elementCount) {
        if (gallery.count !== 0) {
          // Gallery is not empty
          append = (0, _parsers.galleryParser)(gallery, options, type);
          gallery = []; // Reset gallery
        }
      }

      return _react2.default.createElement(
        Fragment,
        { key: index },
        prepend,
        frag,
        append
      );
    })
  );
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = treeParser;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/treeCodeParser.js
// module id = 442
// module chunks = 168707334958949